<template>
	<div>
		<PageBanner img-height="576px"></PageBanner>

		<div id="title" class="subtitle">实验室设备
			&nbsp;<span class="dot">·</span>&nbsp;
			<span class="eng_subtitle">Laboratory Equipment</span>
		</div>
		<SectionDivider class="progress" id="title"></SectionDivider>
		<div style="display: flex;justify-content: center;align-items: center;margin-top: 5vh;">
			<div class="production-list">
				<ProductCard v-for="(item, index) in production_img" :key="index" :item="item"
						:yellow="index % 2 === 1" cont-font-size="20px" img800-width="360px" img800-height="260px" />
			</div>
		</div>
		<div id="title" class="subtitle" >实验室耗材
			&nbsp;<span class="dot">·</span>&nbsp;
			<span class="eng_subtitle" >Laboratory Consumables</span>
		</div>
		<SectionDivider class="progress" id="title"></SectionDivider>
		<div style="display: flex;justify-content: center;align-items: center;margin-top: 5vh;margin-bottom: 5vh;">
			<div class="production-list2">
				<ProductCard v-for="(item, index) in production_img2" :key="index" :item="item"
						:yellow="index % 2 === 1" cont-font-size="20px" img800-width="360px" img800-height="260px" />
			</div>
		</div>
	</div>
</template>

<script>
	import PageBanner from '../components/public/PageBanner.vue'
	import ProductCard from '../components/public/ProductCard.vue'
	import SectionDivider from '../components/public/SectionDivider.vue'
	import { labEquipments, labConsumables } from '../constants/products'
	export default {
		name: 'ProductCenter',
		components: {
			ProductCard,
			PageBanner,
			SectionDivider
		},
		data() {
			return {
				production_img: labEquipments,
				production_img2: labConsumables
			}
		}
	}
</script>

<style scoped>
	#title {
		margin-left: calc(50% - 600px);
	}

	.info {
		left: 33%;
	}

	.contact, .info {
		top: 65%;
		transform: translate(50%, 50%);
		position: absolute;
	}

	.contact {
		left: 47%;
	}

	.subtitle {
		font-size: 2em;
		margin-top: 10vh;
	}

	.dot {
		font-weight: 600;
	}

	.eng_subtitle {
		font-family: Rany;
		font-weight: 500;
		font-size: 30px;
	}

	.progress {
		width: 200px;
		margin-top: 20px;
	}

	/* 行高用 minmax 而非固定值，简介为两行的产品（如混合细胞）才不会溢出被下方内容遮挡 */
	.production-list2, .production-list {
		display: grid;
		grid-template-columns: 400px 400px 400px;
		grid-auto-rows: minmax(520px, auto);
		grid-gap: 20px;
		text-align: center;
	}

	.device_name2 {
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 25px;
		font-weight: 500;
	}

	.device_cont2 {
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 20px;
		white-space: pre-wrap;
	}

	.p_card {
		width: 500px;
	}

	.p_card:hover {
		transform: scale(1.05) translateY(-1px);
	}

	@media screen and (max-width: 1150px) {
		#title {
			margin-left: calc(50% - 450px);
		}

		.production-list, .production-list2 {
			display: grid;
			grid-template-columns: 400px 400px;
			grid-auto-rows: minmax(500px, auto);
			grid-gap: 20px;
			text-align: center;
		}
	}

	@media screen and (max-width: 800px) {
		#title {
			margin-left: calc(50% - 170px);
		}

		.subtitle {
			font-size: 1.1rem;
			margin-top: 5vh;
		}

		.dot {
			font-weight: 600;
		}

		.eng_subtitle {
			font-family: Rany;
			font-weight: 500;
			font-size: 1.1rem;
		}

		.progress {
			width: 120px;
			margin-top: 10px;
		}

		.production-list {
			display: grid;
			grid-template-columns: 400px;
			grid-auto-rows: minmax(400px, auto);
			text-align: center;
			margin-bottom: 3rem;
		}

		.production-list2 {
			display: grid;
			grid-template-columns: 400px;
			grid-auto-rows: minmax(400px, auto);
			text-align: center;
		}
	}
</style>